export default __webpack_public_path__ + "static/media/Home.761eac56.jpg";